import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import constants from 'common/helpers/constants'
import { intlMessageShape } from 'sb-react-intl'

import Button from 'components/_new/Button/Button'

import messages from './messages'


const handleClick = (placement) => () => {
  actions.models.ui.showRequestLoader()

  actions.models.subscription.unskip(placement)
    .finally(() => {
      actions.models.ui.hideRequestLoader()
    })
}

const UnskipButton = (props) => {
  const {
    className, size, placement, color, weight, rightIcon,
    uppercase, title, fullWidth, dataTestId, id, halfPadding,
  } = props

  return (
    <Button
      className={className}
      id={id}
      size={size}
      title={title}
      color={color}
      weight={weight}
      fullWidth={fullWidth}
      rightIcon={rightIcon}
      uppercase={uppercase}
      dataTestId={dataTestId}
      halfPadding={halfPadding}
      onClick={handleClick(placement)}
    />
  )
}

UnskipButton.propTypes = {
  placement: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  weight: PropTypes.string,
  uppercase: PropTypes.bool,
  title: PropTypes.shape(intlMessageShape),
  dataTestId: PropTypes.string,
}

UnskipButton.defaultProps = {
  size: 'md',
  color: 'brand',
  weight: 'medium',
  uppercase: true,
  title: messages.title,
  dataTestId: constants.testIds.profile.orderStatusButtons.unskip,
}


export default UnskipButton
